module.exports = "https://img1.zhuanstatic.com/platform/zz-universal-pages/static/img/heldgoods.a1d361a9.jpg";